import {NavigationButtonPosition, NavigationSectionType} from "../@const";

export function getNavigationPosition(id: NavigationSectionType, defaultValue?: NavigationButtonPosition) {

    if (!defaultValue) {
        switch (id) {
            case NavigationSectionType.HOME     :
            case NavigationSectionType.PROJECTS :
            case NavigationSectionType.QUICK_ADD:
            case NavigationSectionType.MY_ATTENDANCE:
                defaultValue = NavigationButtonPosition.TOP
                break

            case NavigationSectionType.USERS    :
            case NavigationSectionType.CRM      :
            case NavigationSectionType.REPORTS  :
            case NavigationSectionType.TOOLS    :
                defaultValue = NavigationButtonPosition.MORE
                break

            case NavigationSectionType.CHATS    :
            case NavigationSectionType.SEARCH   :
            case NavigationSectionType.SETTINGS :
            case NavigationSectionType.HELP     :
                defaultValue = NavigationButtonPosition.BOTTOM
                break
        }
    }

    return _.get(gd.user.settings.navigation.buttonPositions, id, defaultValue)

}